import { forwardRef } from 'react';
import {
  Textarea,
  TextareaProps,
} from '@design-system/components/textarea/textarea';
import { Typography } from '@design-system/components/typography/typography';
import * as styles from './TextareaWithCounter.css';

type TextareaWithCounterProps = TextareaProps & {
  maxLength: number;
  currentLength: number;
  footerLeft?: React.ReactNode;
};

export const TextareaWithCounter = forwardRef<
  HTMLTextAreaElement,
  TextareaWithCounterProps
>(({ maxLength, currentLength, footerLeft, ...textareaProps }, ref) => (
  <div className={styles.wrapper}>
    <Textarea ref={ref} {...textareaProps} maxLength={maxLength} />
    <div className={styles.footer}>
      <div>{footerLeft}</div>
      <Typography
        variant="body"
        size="small"
        color="N-80"
        className={styles.counter}
      >
        {currentLength}/{maxLength}
      </Typography>
    </div>
  </div>
));
